<!-- <p>action-list works!</p> -->
<div class="main-actions-div">
    <div class="alignRow" style="margin-bottom: 0.5em;">
        <span style="font-size: large; font-weight: bolder;">{{titleText}}</span>
        <span class="toolbar-spacer"></span>
        <div class="alignRow myActions-checkbox">
            <span>Only Show my Actions</span>
            <mat-checkbox color="primary" [checked]="myActionsOnly"
                (change)="toggleMyActionsOnly($event)"></mat-checkbox>
        </div>
        <button mat-raised-button class="filter-button" [matMenuTriggerFor]="filterMenu">
            <span>Filters</span>
            <mat-icon>tune</mat-icon>
        </button>
    </div>
    <div *ngIf="!useTable">
        <div class="list-div">
            <div class="action-item">
                <span>Asset</span>
                <span>Action Type</span>
                <span>Date Created</span>
            </div>
            <ejs-listbox [dataSource]='filteredActions' [fields]="fields" class="listbox-container">
                <ng-template #itemTemplate let-data>
                    <div class="action-item ejs-listbox-item" (click)="goToActionDetails(data)">
                        <span>{{ data.AssetName }}</span>
                        <span style="font-weight: bold;">{{ getActionTypeFromValue(data.ActionType) }}</span>
                        <span style="text-decoration: underline;">{{ convertEpoch(data.Timestamp) }}</span>
                    </div>
                </ng-template>
            </ejs-listbox>
        </div>
    </div>
    <div class="filter-table-div" *ngIf="useTable">
        <mat-form-field>
            <mat-label>Search by Action, Asset, or Date Created</mat-label>
            <input matInput (keyup)="onFilteringActions($event)" placeholder="" #input>
        </mat-form-field>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort [matSortDirection]="'asc'" [matSortActive]="'TargetCompletionTimestamp'">
                <ng-container matColumnDef="asset" *ngIf="actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Asset </th>
                    <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="goToActionDetails(row)">
                        <span>{{ row.AssetName }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action type" style="cursor: pointer;">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Action Type</th>
                    <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                        (click)="goToActionDetails(row)">
                        <span>{{ getActionTypeFromValue(row.ActionType) }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="date created" style="cursor: pointer;">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Created </th>
                    <td style="cursor: pointer; text-decoration: underline;" mat-cell *matCellDef="let row"
                        (click)="goToActionDetails(row)">
                        <span>{{ convertEpoch(row.Timestamp) }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="created by" style="cursor: pointer;">
                    <th mat-header-cell *matHeaderCellDef> Created By </th>
                    <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="goToActionDetails(row)">
                        <span>{{ row.CreatedByUserSub }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="assigned to" style="cursor: pointer;">
                    <th mat-header-cell *matHeaderCellDef> Assigned To </th>
                    <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="goToActionDetails(row)">
                        <span>{{ row.AssignedToUserName }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="target completion" style="cursor: pointer;">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Target Completion Date </th>
                    <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="goToActionDetails(row)">
                        <span>{{ convertEpochNoTime(row.TargetCompletionTimestamp) }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="date completed" style="cursor: pointer;">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Completed </th>
                    <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="goToActionDetails(row)">
                        <span>{{ convertEpochNoTime(row.CompletedTimestamp) }}</span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row class="table-row"
                    [ngStyle]="{'background-color': checkIfOverdue(row) ? 'var(--action-bg-color)' : ''}"
                    *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td *ngIf="input.value != ''" class="mat-cell" colspan="4">No Data Matching the Filter:
                        "{{input.value}}"</td>
                    <td *ngIf="input.value == ''" class="mat-cell" colspan="4">No Data Matching the Filter</td>
                </tr>
            </table>
            <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
                aria-label="Select page of rules"></mat-paginator>
        </div>
    </div>
</div>

<mat-menu #filterMenu>
    <div class="filter-switch-div">
        <div class="enabled-switch-div">
            <span style="margin-right: 0.2em;" [ngStyle]="{'color': overDueOnly ? 'lightgray' : ''}">Completed</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="toggleCompleted($event)" [disabled]="overDueOnly"></mat-checkbox>
        <div class="enabled-switch-div">
            <span style="margin-right: 0.2em;" [ngStyle]="{'color': titleText.includes('Completed') ? 'lightgray' : ''}">Overdue</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" [checked]="overDueOnly"
            (change)="toggleOverdue($event)" [disabled]="titleText.includes('Completed')"></mat-checkbox>
    </div>
    <!-- <div class="all-types">
        <div class="filter-switch-div-small" *ngFor="let type of actionTypes">
            <div class="enabled-switch-div">
                <span style="margin-right: 0.2em;">{{type.text}}</span>
            </div>
            <mat-checkbox color="primary" (click)="$event.stopPropagation()"></mat-checkbox>
        </div>
    </div> -->
</mat-menu>